/* eslint-disable @typescript-eslint/no-explicit-any */
import { Active, UniqueIdentifier } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';
import { TInviteRequest } from '@gen2/api/invite-requests/api';
import { DrawerRequestBox } from '../shared-drawer.styles';
import {
  SortableRequestItem,
  SortableRequestItemProps,
} from './sortable-request-item';

export type RequestListType = 'invite' | 'template' | 'followup';

export interface SortableRequestListProps {
  items?: SortableRequestItemProps[] | TInviteRequest[];
  onChange?(items: SortableRequestItemProps[] | TInviteRequest[]): void;
  type?: RequestListType;
  active?: Active | null;
  onSelect?: (id: UniqueIdentifier) => void;
  selectedIds?: string[];
}

const normalizeItems = (
  items: SortableRequestItemProps[] | TInviteRequest[] = [],
): (SortableRequestItemProps & { id: string | number; title: string })[] => {
  return (items as any[]).filter(
    (item): item is { id: string | number; title: string } =>
      !!item && !!item.id && !!item.title,
  );
};

export const SortableRequestList = ({
  items = [],
  onSelect,
  selectedIds = [],
}: SortableRequestListProps) => {
  return (
    <SortableContext items={items}>
      <DrawerRequestBox>
        {normalizeItems(items).map((item) => (
          <SortableRequestItem
            key={item.id}
            id={item.id}
            title={item.title}
            selected={selectedIds.includes(String(item.id))}
            onSelect={onSelect ? () => onSelect(item.id) : undefined}
          />
        ))}
      </DrawerRequestBox>
    </SortableContext>
  );
};
